import Application from "../../Application";
import IndexTypeCategoryPresenter, {
  IIndexTypeCategoryPresenter
} from "../presenter/IndexTypeCategoryPresenter";
import GetAllIndexTypeCategoriesInteractor from "./GetAllIndexTypeCategoriesInteractor";

export default class ShowIndexTypeCategoriesInteractor {
  private application: Application;
  private output?: IIndexTypeCategoryPresenter;
  private getAllIndexTypeCategoriesInteractors: GetAllIndexTypeCategoriesInteractor;

  constructor({ application, getAllIndexTypeCategories }: any) {
    this.application = application;
    this.getAllIndexTypeCategoriesInteractors = getAllIndexTypeCategories;
  }

  private async getAllCategories() {
    return this.getAllIndexTypeCategoriesInteractors.execute();
  }

  execute() {
    this.output = IndexTypeCategoryPresenter({
      application: this.application,
      initialState: {
        indexTypeCategories: [],
        categoryCandidates: []
      }
    });
    this.getAllCategories().then(this.output.loadAllIndexTypeCategories);
    return this.output;
  }
}
